import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import { ICreateAccountResource, ICreateAccountResponse, LoginPageType } from 'JS/types/Account';
import { IJoinRewardsStep, IVerifyUserData } from 'JS/types/rewards';
import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectAccountPage',
  props: {
    createAccountResponse: null,
    createAccountRequest: null,
    isFullScreenVersion: { type: Boolean }
  },
  emits: ["go-to-rewards", "go-back"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'go-to-rewards', page: IJoinRewardsStep, data?: IVerifyUserData, createAccountRequest?: ICreateAccountResource, returnPage?: LoginPageType): void;
	(event: 'go-back'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	createAccountResponse: ICreateAccountResponse;
	createAccountRequest: ICreateAccountResource;
	isFullScreenVersion: boolean;
}





const headerFocuser = ref<HTMLElement | null>(null);

function handleSelectAccount(selectedAccount: 1 | 2) {
	if (selectedAccount === 1) {
		//Match Phone
		emit('go-to-rewards',
			'verification-join',
			{ phone: props.createAccountResponse.phone, email: props.createAccountResponse.email, variant: 'verification-join', redactedData: props.createAccountResponse.redactedData },
			{ ...props.createAccountRequest, hasDesyncedRewards: true },
			'select-account'
		);
	} else {
		//Match Email
		emit('go-to-rewards',
			'verification-join',
			{ phone: props.createAccountResponse.secondPhone, email: props.createAccountResponse.secondEmail, variant: 'verification-join', redactedData: props.createAccountResponse.secondRedactedData },
			props.createAccountRequest,
			'select-account',
		);
	}
}


onMounted(()=> {
	headerFocuser.value?.focus();
});

return { __sfc: true,props, emit, headerFocuser, handleSelectAccount, Icon, LinkButton }
}

})